import type { Theme, SxProps } from '@mui/material/styles';
import { forwardRef, useState } from 'react';
import Box from '@mui/material/Box';
import Iconify from './iconify';

// ----------------------------------------------------------------------

export type FlagIconProps = {
    code?: string;
    sx?: SxProps<Theme>;
    isCircle?: boolean;
};

/** Rectangular flags: the flag-icons SVGs, pinned in package.json and copied into
 *  the build by webpack. Bundling them as an Iconify set would cost ~500 KB gzipped. */
const RECT_FLAGS_PATH = '/assets/flags/4x3';

export const FlagIcon = forwardRef<HTMLSpanElement, FlagIconProps>(
    ({ code, sx, isCircle = true }, ref: any) => {
        const [failedCode, setFailedCode] = useState<string>();

        if (!code) {
            return null;
        }

        if (!isCircle) {
            // Like a missing Iconify icon, a code flag-icons does not carry shows nothing.
            if (failedCode === code) return null;

            return (
                <Box
                    component="img"
                    key={code}
                    ref={ref}
                    src={`${RECT_FLAGS_PATH}/${code}.svg`}
                    alt=""
                    onError={() => setFailedCode(code)}
                    // `contain` letterboxes the 4:3 flag the way the Iconify SVG did.
                    sx={{ width: 16, height: 16, lineHeight: 1, display: 'inline-flex', verticalAlign: 'middle', objectFit: 'contain', ...sx }}
                />
            );
        }

        return (
            <Iconify
                key={code}
                icon={`circle-flags:${code}`}
                ref={ref}
                sx={{ width: 16, height: 16, lineHeight: 1, display: 'inline-flex', verticalAlign: 'middle', ...sx }}
            />
        );
    }
);
